import React from 'react';
import ReactDOM from 'react-dom';
import EzTopApp from './components/EzTopApp2.0';

import * as serviceWorker from './serviceWorker';

// import 'bootstrap/dist/css/bootstrap.min.css';



let render = function(){
    ReactDOM.render(<EzTopApp />, document.getElementById('tf-eztop-app'));
};

if(typeof window.apps === 'undefined'){
    window.apps = {};
}
window.apps.eztopApp = render;
 // window.apps.eztopApp();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
